<div class="container-fluid py-4">
  <div class="row mb-4 justify-content-center">
    <ng-container *ngFor="let card of resumenCards; index as i">
      <div class="col-3 col-md-2">
        <div
          class="card card-stats initial-card"
          [ngClass]="{ 'card-stats__selected': i === 0 }"
          [routerLink]="card.route"
          [style.cursor]="card.route || i === 0 ? 'pointer' : 'default'"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-6 col-lg-6">
                <div
                  class="icon-big text-center text-dark rounded shadow icon-card"
                  [ngClass]="card.bgClass"
                >
                  <i [class]="card.icon"></i>
                </div>
              </div>

              <div class="col-7 d-flex flex-column justify-content-center">
                <p class="card-category mb-0">{{ card.label }}</p>
                <h4
                  class="card-title mb-0"
                  [ngClass]="{ 'text-dark': i === 0, 'text-white': i !== 0 }"
                >
                  {{ card.value }}
                </h4>
              </div>
            </div>
          </div>

          <div class="card-footer">
            <div class="stats">
              <small [class]="i == 0 ? 'desc__selected' : 'desc'">{{
                card.desc
              }}</small>
            </div>
          </div>
        </div>
      </div>

      <!-- SALTO DE FILA después de la 4ta tarjeta (i = 3) -->
      <div *ngIf="i === 3" class="w-100"></div>
    </ng-container>
  </div>

  <div class="row mb-6 mt-4">
    <div class="col-12 d-flex align-items-center justify-content-between">
      <div class="flex-grow-1 text-center">
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/metricsDaily']"
        >
          Metrics daily
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/metricsWeekly']"
        >
          Metrics weekly
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/actionsBacklog']"
        >
          Actions backlog
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/cannibalClusters']"
        >
          Cannibal clusters
        </a>
        <a class="btn btn-dark btn-sm btn-reg"> Keyword insights </a>
      </div>
    </div>
    <div class="col-12 d-flex align-items-center justify-content-between">
      <div class="flex-grow-1 text-center">
        <a
          class="btn btn-light btn-sm btn-new"
          [routerLink]="['/observability/seo/cannibalEdges']"
        >
          Cannibal edges
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/localSeo/reviews']"
        >
          Reviews
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/technicalAudits']"
        >
          Technical Audits
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/sitemapAudits']"
        >
          Sitemap Audits
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/offPagePerformance']"
        >
          Off-page
        </a>
      </div>
    </div>
  </div>

  <div class="row">
    <!-- Summary Cards -->
    <div class="col-lg-2 col-md-4 col-sm-6">
      <div class="card card-stats">
        <div class="card-header card-header-info card-header-icon">
          <div class="card-icon">
            <i class="material-icons">assessment</i>
          </div>
          <p class="card-category">Total</p>
          <h3 class="card-title">{{ summary.total }}</h3>
        </div>
      </div>
    </div>
    <div class="col-lg-2 col-md-4 col-sm-6">
      <div class="card card-stats">
        <div class="card-header card-header-success card-header-icon">
          <div class="card-icon">
            <i class="material-icons">info</i>
          </div>
          <p class="card-category">Informational</p>
          <h3 class="card-title">{{ summary.informational }}</h3>
        </div>
      </div>
    </div>
    <div class="col-lg-2 col-md-4 col-sm-6">
      <div class="card card-stats">
        <div class="card-header card-header-primary card-header-icon">
          <div class="card-icon">
            <i class="material-icons">shopping_cart</i>
          </div>
          <p class="card-category">Transactional</p>
          <h3 class="card-title">{{ summary.transactional }}</h3>
        </div>
      </div>
    </div>
    <div class="col-lg-2 col-md-4 col-sm-6">
      <div class="card card-stats">
        <div class="card-header card-header-warning card-header-icon">
          <div class="card-icon">
            <i class="material-icons">monetization_on</i>
          </div>
          <p class="card-category">Commercial</p>
          <h3 class="card-title">{{ summary.commercial }}</h3>
        </div>
      </div>
    </div>
    <div class="col-lg-2 col-md-4 col-sm-6">
      <div class="card card-stats">
        <div class="card-header card-header-danger card-header-icon">
          <div class="card-icon">
            <i class="material-icons">location_on</i>
          </div>
          <p class="card-category">Local</p>
          <h3 class="card-title">{{ summary.local }}</h3>
        </div>
      </div>
    </div>
    <div class="col-lg-2 col-md-4 col-sm-6">
      <div class="card card-stats">
        <div class="card-header card-header-default card-header-icon">
          <div class="card-icon">
            <i class="material-icons">shuffle</i>
          </div>
          <p class="card-category">Mixed</p>
          <h3 class="card-title">{{ summary.mixed }}</h3>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header card-header-info">
          <div class="row">
            <div class="col-md-6">
              <h4 class="card-title">SEO Keyword Insights</h4>
              <p class="card-category">
                Keyword research and content planning insights
              </p>
            </div>
            <div class="col-md-6 text-right">
              <button
                mat-raised-button
                class="btn btn-white btn-round btn-just-icon"
                (click)="loadInsights()"
                [disabled]="loading"
                matTooltip="Refresh"
              >
                <i class="material-icons">refresh</i>
                <div class="ripple-container"></div>
              </button>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div *ngIf="loading" class="text-center">
            <mat-spinner diameter="40" style="margin: 20px auto"></mat-spinner>
          </div>

          <div class="table-responsive" *ngIf="!loading">
            <table mat-table [dataSource]="insightList" class="table">
              <ng-container matColumnDef="url">
                <th mat-header-cell *matHeaderCellDef class="thead">URL</th>
                <td mat-cell *matCellDef="let element">
                  <a
                    [href]="'http://courierandbeyond.com/' + element.url"
                    target="_blank"
                    class="text-info"
                  >
                    {{ element.url }}
                  </a>
                </td>
              </ng-container>

              <ng-container matColumnDef="primaryKeyword">
                <th mat-header-cell *matHeaderCellDef class="thead">
                  Primary Keyword
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.primaryKeyword || element.currentKeyword }}
                </td>
              </ng-container>

              <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef class="thead">Type</th>
                <td mat-cell *matCellDef="let element">
                  <span class="badge badge-default">{{ element.type }}</span>
                </td>
              </ng-container>

              <ng-container matColumnDef="searchIntent">
                <th mat-header-cell *matHeaderCellDef class="thead">
                  Search Intent
                </th>
                <td mat-cell *matCellDef="let element">
                  <span
                    class="badge"
                    [ngClass]="{
                      'badge-info': element.searchIntent === 'informational',
                      'badge-success': element.searchIntent === 'transactional',
                      'badge-warning': element.searchIntent === 'commercial',
                      'badge-danger': element.searchIntent === 'local',
                      'badge-primary': element.searchIntent === 'navigational',
                      'badge-default': element.searchIntent === 'mixed',
                    }"
                    >{{ element.searchIntent | uppercase }}</span
                  >
                </td>
              </ng-container>

              <ng-container matColumnDef="lastSeenAt">
                <th mat-header-cell *matHeaderCellDef class="thead">
                  Last Seen At
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.lastSeenAt | date : "mediumDate" }}
                </td>
              </ng-container>

              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="thead"></th>
                <td mat-cell *matCellDef="let element">
                  <button
                    mat-raised-button
                    type="button"
                    class="btn btn-info btn-link btn-just-icon"
                    [routerLink]="[
                      '/observability/seo/keywordInsights',
                      element._id
                    ]"
                  >
                    <i class="material-icons">visibility</i>
                  </button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr
                mat-row
                *matRowDef="let element; columns: displayedColumns"
              ></tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
